module.exports = __webpack_public_path__ + "static/media/SFDR.bbc6773b.pdf";